module.exports = __webpack_public_path__ + "static/media/register-360w.93834d6f.jpg";